module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Contact_title")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Contact_content")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "display": "inline-block",
      "background-color": "white",
      "padding": "15px",
      "margin-bottom": "100px",
      "border-right": "solid #e4ab34 10px",
      "box-shadow": "0 2px 4px rgba(0,0,0,0.50)"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tie"
  }, [_c('div', {
    staticClass: "title-size",
    staticStyle: {
      "color": "#4A4A4A"
    }
  }, [_vm._v("\n                        " + _vm._s("联系地址：中国广州番禺区南站喜街") + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-size",
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("\n                        " + _vm._s("联系电话：020-88834737") + "\n                    ")]), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "officePics-desktop"
    }
  }, [_c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_2.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_3.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_4.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xcx"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "imgs/gzh_qr.jpg",
      "alt": "同熙商业公众号"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("同熙商业公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "imgs/xcx_qr.jpg",
      "alt": "玩转喜街小程序"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("玩转喜街小程序")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f19357e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 99
// module chunks = 20